import {
  CardDocumentsDataProps,
  getExternalLogisticDocuments,
  getInternalLogisticDocuments,
} from '@/components'
import { SaleOrderProps } from '@/types'

const getFinanceDocuments = (
  t: (value: string) => string,
  saleOrder?: SaleOrderProps,
) => {
  const docs: { file: string; title: string }[] = []

  saleOrder?.invoices?.forEach((invoice, index) => {
    if (invoice?.pdfFile) {
      docs.push({
        file: invoice.pdfFile || '',
        title:
          t('orderCenterShowTabClientDepositInvoiceTitle') +
          ` ${saleOrder?.invoices.length > 1 ? index + 1 : ''}`,
      })
    }

    if (invoice?.xmlFile) {
      docs.push({
        file: invoice.xmlFile || '',
        title:
          t('orderCenterShowTabClientDepositInvoiceTitle') +
          ` ${saleOrder?.invoices.length > 1 ? index + 1 : ''}`,
      })
    }

    if (invoice?.deductionPdfFile) {
      docs.push({
        file: invoice.deductionPdfFile || '',
        title: t('orderCenterShowTabClientDeductionTitlePdf'),
      })
    }

    if (invoice?.deductionXmlFile) {
      docs.push({
        file: invoice.deductionPdfFile || '',
        title: t('orderCenterShowTabClientDeductionTitleXml'),
      })
    }
  })

  saleOrder?.payments?.forEach((payment, index) => {
    if (payment?.proof) {
      docs.push({
        file: payment.proof || '',
        title:
          t('orderCenterShowTabClientProofTitle') +
          ` ${saleOrder?.payments.length > 1 ? index + 1 : ''}`,
      })
    }
  })

  return docs
}

export const getInternalDocuments = (
  t: (value: string) => string,
  tLogistic: (value: string) => string,
  saleOrder?: SaleOrderProps,
): CardDocumentsDataProps[] | undefined => {
  if (!saleOrder) return undefined

  const result: CardDocumentsDataProps[] = []

  const logisticInternalDocuments = {
    ...getInternalLogisticDocuments(tLogistic, saleOrder.shipments?.[0]),
    title: t('orderCenterShowTabDocumentsLogisticLabel'),
  }

  if (
    logisticInternalDocuments?.data &&
    logisticInternalDocuments?.data?.length > 0
  ) {
    result.push(logisticInternalDocuments)
  }

  return result
}

export const getExternalDocuments = (
  t: (value: string) => string,
  tLogistic: (value: string) => string,
  saleOrder?: SaleOrderProps,
): CardDocumentsDataProps[] | undefined => {
  if (!saleOrder) return undefined

  const result: CardDocumentsDataProps[] = []

  const financeDocuments = {
    data: getFinanceDocuments(t, saleOrder),
    title: t('orderCenterShowTabDocumentsFinancesLabel'),
  }

  if (financeDocuments?.data && financeDocuments?.data?.length > 0) {
    result.push(financeDocuments)
  }

  const logisticExternalDocuments = {
    ...getExternalLogisticDocuments(tLogistic, saleOrder.shipments?.[0]),
    title: t('orderCenterShowTabDocumentsLogisticLabel'),
  }

  if (
    logisticExternalDocuments?.data &&
    logisticExternalDocuments?.data?.length > 0
  ) {
    result.push(logisticExternalDocuments)
  }

  if (saleOrder?.buyer?.taxSituation) {
    result.push({
      title: t('orderCenterShowTabDocumentsProfileLabel'),
      data: [
        {
          title: t('orderCenterShowTabProfileTaxSituationTitle'),
          file: saleOrder.buyer.taxSituation,
        },
      ],
    })
  }

  return result
}
